import { FiChevronRight, FiCheckCircle } from "react-icons/fi";
import { ClipboardIcon } from "@heroicons/react/24/outline";
import diagramImg from "../../assets/Netraa_Architecture.png"
import diagramDarkImg from "../../assets/Netraa_Architecture_dark.png"
import React, { useState } from "react";
  // Reusable CodeBlock component
  const CodeBlock = ({ code }) => {
    const [copied, setCopied] = React.useState(false);
  
    const copyToClipboard = () => {
      navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    };
  
    return (
      <div className="relative bg-black/90 rounded-lg overflow-hidden mb-4">
        <div className="absolute top-2 right-2 z-10">
          <button
            onClick={copyToClipboard}
            className="p-1.5 rounded text-white"
            title="Copy to clipboard"
          >
            {copied ? (
              <span className="text-green-400 text-lg leading-none">✔</span>
            ) : (
              <ClipboardIcon className="w-4 h-4" />
            )}
          </button>
        </div>
  
        <pre className="text-xs text-green-400 p-4 pt-8 font-mono overflow-x-auto">
          {code}
        </pre>
      </div>
    );
  };

export function renderNetraaAPM() {

  return (
  <div className="transition-opacity duration-300">

    {/* Breadcrumb */}
    <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
      <a className="hover:text-primary hover:underline" href="#">Netraa APM</a>
      <FiChevronRight />
      <span>Deployment and Configuration</span>
      <FiChevronRight />
      <span className="text-[#1b140d] dark:text-white font-medium">
        Offline Setup Guide
      </span>
    </nav>

    {/* Header */}
    <div className="mb-10">
      <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-wider text-orange-600 uppercase bg-orange-100 rounded-full dark:bg-orange-900/30 dark:text-orange-400">
        Documentation
      </span>
      <h1 className="text-4xl font-extrabold tracking-tight mb-4">
        <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">
          Netraa{" "}
        </span>
        On-Prem Installation Guide
      </h1>
      <p className="text-lg text-text-muted dark:text-gray-400 leading-relaxed">
        A comprehensive guide for deploying the full Netraa observability platform in enterprise,
        air-gapped, or on-premises environments.
      </p>
    </div>

    {/* Main Card Wrapper (same style as Infra page) */}
    <div className="bg-surface-light dark:bg-surface-dark rounded-xl shadow-subtle">

      {/* Deployment Summary Cards */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
        {[
          { title: "Deployment Environment", value: "Offline / Air-Gapped" },
          { title: "Operating System", value: "RHEL 9.x" },
          { title: "Container Runtime", value: "Docker CE / Compose" },
        ].map((item, idx) => (
          <div key={idx} className="p-4 rounded-xl border border-border-color dark:border-border-dark shadow-sm">
            <p className="text-[10px] uppercase font-bold text-text-muted mb-1">
              {item.title}
            </p>
            <p className={`text-sm font-bold ${idx === 0 ? "text-primary" : "text-text-main dark:text-white"}`}>
              {item.value}
            </p>
          </div>
        ))}
      </div>

      {/* Important Note */}
      <div className="bg-amber-50 dark:bg-amber-900/20 border-l-4 border-amber-500 p-4 mb-12 rounded-r-lg">
        <div className="flex items-center gap-2 mb-1">
          <span className="material-symbols-outlined text-amber-600 dark:text-amber-400 text-sm">warning</span>
          <h4 className="text-sm font-bold text-amber-800 dark:text-amber-300">
            IMPORTANT NOTE
          </h4>
        </div>
        <p className="text-xs text-amber-700 dark:text-amber-400 leading-relaxed">
          This guide is specifically verified for <strong>RHEL 9</strong>. Ensure your system has the base OS repositories or the provided Netraa RPM bundle if operating in a fully restricted network.
        </p>
      </div>

      {/* Architecture Section */}
      <section className="mb-10 scroll-mt-24" id="architecture">
        <h2 className="text-2xl font-bold mb-6 flex items-center gap-3">
          <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-orange-100 dark:bg-orange-900/30 text-primary border border-orange-200 dark:border-orange-900/50">
            <span className="material-symbols-outlined text-[24px]">schema</span>
          </span>
          Netraa Platform Architecture
        </h2>

        {/* <div className="w-full aspect-[14/9] bg-gray-100 dark:bg-white/5 border border-dashed border-gray-300 dark:border-gray-700 rounded-xl flex items-center justify-center">
          <img
            src={diagramImg}
            alt="High-Level Platform Diagram"
            className="w-45 h-45 object-contain"
          />
        </div> */}
  <div className="w-full flex items-center justify-center">
  {/* Light mode */}
  <img
    src={diagramImg}
    alt="High-Level Platform Diagram"
    className="block dark:hidden w-full max-w-xl h-auto object-contain"
  />
  {/* Dark mode */}
  <img
    src={diagramDarkImg}
    alt="High-Level Platform Diagram"
    className="hidden dark:block w-full max-w-xl h-auto object-contain"
  />
</div>
      </section>

      {/* Prerequisites */}
      {/* <section className="mb-10 scroll-mt-24" id="prerequisites">
        <h2 className="text-2xl font-bold mb-6 flex items-center gap-3">
          <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/30 text-blue-600 border border-blue-200 dark:border-blue-900/50">
            <span className="material-symbols-outlined text-[24px]">fact_check</span>
          </span>
          1. Common Prerequisites
        </h2>

        <ul className="list-disc pl-5 space-y-1 text-text-muted text-sm">
          <li>Sudo or Root access to the host machine.</li>
          <li>Firewalld/IPtables configured.</li>
          <li>Dedicated partition required.</li>
          <li>Netraa bundle downloaded.</li>
        </ul>
      </section> */}

      {/* FULL TABLE (UNCHANGED) */}
      {/* <section className="mb-16 scroll-mt-24" id="master-sizing">
        <h2 className="text-2xl font-bold mb-6">Environment Specifications Matrix</h2>

        <div className="overflow-x-auto border rounded-xl">
          <table className="text-left border-collapse"> */}
             {/* HEADER */}
    {/* <thead className="text-[11px]">
      <tr>
        <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
          Deployment Scale
        </th>
        <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
          Component
        </th>
        <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted text-center border border-border-color dark:border-border-dark">
          Qty
        </th>
        <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
          OS
        </th>
        <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
          CPU (Cores)
        </th>
        <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
          Memory (GB)
        </th>
        <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
          Storage
        </th>
        <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
          Source
        </th>
        <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
          Ports
        </th>
        <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
          Software
        </th>
      </tr>
    </thead> */}

    {/* BODY */}
    {/* <tbody className="text-[11px]"> */}

      {/* Demo Env */}
      {/* <tr className="bg-white dark:bg-transparent">
        <td className="px-3 py-4 font-bold text-primary border border-border-color dark:border-border-dark">
          Demo Env
        </td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">Single VM</td>
        <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">1</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">Ubuntu 24.04+</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">6</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">16</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">250 GB</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">Internal/Monitoring</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">12001, 11800</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">Docker/Compose</td>
      </tr> */}

      {/* 10 Entities */}
      {/* <tr className="bg-gray-50/50 dark:bg-white/[0.02]">
        <td className="px-3 py-4 font-bold align-top border border-border-color dark:border-border-dark" rowSpan={3}>
          10 Entities (250 TPS)
        </td>

        <td className="px-3 py-4 border border-border-color dark:border-border-dark">App Server</td>
        <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">1</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark" rowSpan={3}>
          Ubuntu 24.04 Minimal / RedHat 9 / CentOS 9 / Oracle Linux 9
        </td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">8</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">16</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">100 GB SSD</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">Application Services</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">80, 443</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark" rowSpan={3}>
          Docker v26.1.4, Docker Compose v2.28.1
        </td>
      </tr>

      <tr className="bg-gray-50/50 dark:bg-white/[0.02]">
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">Netraa Cluster</td>
        <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">1</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">8</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">16</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">200 GB SSD</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">Platform Engine</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">11800,12800,4444</td>
      </tr>

      <tr className="bg-gray-50/50 dark:bg-white/[0.02]">
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">DB Cluster</td>
        <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">1</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">8</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">16</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">500 GB NVMe</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">ES + MySQL</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">9200, 3306</td>
      </tr> */}

      {/* 50 Entities */}
      {/* <tr>
        <td className="px-3 py-4 font-bold align-top border border-border-color dark:border-border-dark" rowSpan={3}>
          50 Entities (250 TPS)
        </td>

        <td className="px-3 py-4 border border-border-color dark:border-border-dark">App Server</td>
        <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">2</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark" rowSpan={3}>
          Ubuntu 24.04 Minimal / RedHat 9 / CentOS 9 / Oracle Linux 9
        </td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">8</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">16</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">250 GB SSD</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">UI + Microservices</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">80, 443, 8080</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark" rowSpan={3}>
          Docker v26.1.4, Docker Compose v2.28.1
        </td>
      </tr>

      <tr>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">Netraa Cluster</td>
        <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">2</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">8</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">32</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">500 GB SSD</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">Distributed Platform</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">11800,12800,4444</td>
      </tr>

      <tr>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">DB Cluster</td>
        <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">3</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">16</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">64</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">1 TB NVMe</td>
        <td className="px-3 py-4 border border-border-color dark:border-border-dark">HA Storage Layer</td>
        <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">9200, 9300, 3306</td>
      </tr>

    </tbody>
          </table>
        </div>
      </section> */}

      {/* Docker Installation */}
      <section className="mb-10 scroll-mt-24" id="docker-install">
        <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
          <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-cyan-100 dark:bg-cyan-900/30 text-cyan-600 border border-cyan-200 dark:border-cyan-900/50">
            <span className="material-symbols-outlined text-[24px]">terminal</span>
          </span>
          Docker & Docker Compose
        </h2>
        <p className="text-sm text-text-muted mb-4">
          Install the core runtime engine using the RHEL-specific RPM packages provided in the bundle.
        </p>
        <CodeBlock code={`# Extract the platform bundle
tar -xvf netraa-installer-rhel9.tar.gz
cd netraa-installer/runtime
# Install Docker using the local RPMs (RHEL 9)
sudo dnf localinstall -y *.rpm
# Verify installation and start service
sudo systemctl enable --now docker
docker --version
docker compose version`} />
      </section>

      {/* PART 1: Database Layer */}
      <section className="scroll-mt-24" id="part-1">
        <div className="flex items-center gap-4 mb-2">
          <span className="text-sm font-black bg-primary text-white w-8 h-8 rounded flex items-center justify-center shrink-0">1</span>
          <h2 className="text-2xl font-bold text-text-main dark:text-white">PART 1: Database Layer</h2>
        </div>
        <div className="rounded-xl p-6">
          <div>
            <h4 className="text-sm font-bold mb-2">Image Loading</h4>
            <p className="text-xs text-text-muted mb-3">Initialize the local registry with MySQL and Elasticsearch images.</p>
            <CodeBlock code={`gunzip -c netraa-db-images.tar.gz | docker load`} />
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="p-4 bg-gray-100 dark:bg-white/5 rounded-lg ">
              <h5 className="text-xs font-bold uppercase text-text-muted mb-3 flex items-center gap-2">
                <span className="material-symbols-outlined text-[14px]">storage</span> Elasticsearch
              </h5>
              <CodeBlock code={`unzip elasticsearch.zip
cd elasticsearch
docker compose up -d`} />
            </div>
            <div className="p-4 bg-gray-100 dark:bg-white/5 rounded-lg ">
              <h5 className="text-xs font-bold uppercase text-text-muted mb-3 flex items-center gap-2">
                <span className="material-symbols-outlined text-[14px]">database</span> MySQL
              </h5>
              <CodeBlock code={`unzip mysql-setup.zip
cd mysql-setup
docker compose up -d`} />
            </div>
          </div>
        </div>
      </section>

      {/* PART 2: AOP Layer */}
      <section className="scroll-mt-24" id="part-2">
        <div className="flex items-center gap-4">
          <span className="text-sm font-black bg-primary text-white w-8 h-8 rounded flex items-center justify-center shrink-0">2</span>
          <h2 className="text-2xl font-bold text-text-main dark:text-white">PART 2: AOP Layer</h2>
        </div>
        <div className=" rounded-xl p-6">
          <p className="text-sm text-text-muted mb-4">Deploy the Netraa AOP (Apmosys Observability Platform) core services.</p>
          <CodeBlock code={`tar -xvf netraa-aop-v2.4.tar
docker load -i netraa-aop-images.tar
vi config/application.yml`} />
          <p className="text-xs font-bold text-text-muted mb-2 uppercase">Configuration Snippet (application.yml)</p>
          <CodeBlock code={`storage:
  elasticsearch:
    clusterNodes: "127.0.0.1:9200" # Update with your node IP
    protocol: "http"`} />
          <CodeBlock code={`docker compose up -d`} />

          {/* <button className="mt-4 px-4 py-2 bg-text-main dark:bg-white text-white dark:text-text-main text-xs font-bold rounded">
            docker compose up -d
          </button> */}
        </div>
      </section>

      {/* PART 3: Netraa APM Layer */}
      <section className="scroll-mt-24" id="part-3">
        <div className="flex items-center gap-4 mb-2">
          <span className="text-sm font-black bg-primary text-white w-8 h-8 rounded flex items-center justify-center shrink-0">3</span>
          <h2 className="text-2xl font-bold text-text-main dark:text-white">PART 3: Netraa APM Layer</h2>
        </div>
        <div className="bg-surface-light dark:bg-surface-dark rounded-xl p-6 shadow-subtle">
          <p className="text-sm text-text-muted mb-4">Final stage: Deploying the UI and monitoring microservices cluster.</p>
          <CodeBlock code={`tar -xvf netraa-apm-v2.4.tar
docker load -i apm-services.tar
vi .env`} />
          <p className="text-xs font-bold text-text-muted mb-2 uppercase">Environment Parameters (.env)</p>
          <CodeBlock code={`MYSQL_URL=jdbc:mysql://172.17.0.1:3306/netraa_db
ELASTIC_HOST=172.17.0.1
ELASTIC_PORT=9200
AOP_ENDPOINT=http://aop-server:11800`} />
          <div className="flex items-center gap-3">
            <div className="flex-1 h-px"></div>
            <span className="text-[10px] font-bold text-text-muted uppercase">Deployment Command</span>
            <div className="flex-1 h-px"></div>
          </div>
          <CodeBlock code={`docker compose up -d`} />
        </div>
      </section>

      {/* License Activation */}
      <section className="scroll-mt-24" id="license-activation">
        <div className="">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-extrabold text-text-main dark:text-white mb-4">License Activation & Finalization</h2>
            <p className="text-text-muted text-gray-500">Follow these steps to authorize your on-prem installation.</p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            <div className="space-y-4">
              <div className="flex gap-4">
                <span className="text-xs font-bold w-6 h-6 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center shrink-0 mt-0.5">1</span>
                <p className="text-sm"><span className="font-bold">Request Key:</span> Send the System ID to <code className="text-primary underline">support@netraa.io</code>.</p>
              </div>
              <div className="flex gap-4">
                <span className="text-xs font-bold w-6 h-6 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center shrink-0 mt-0.5">2</span>
                <div className="text-sm">
                  <p className="font-bold mb-1">Default Credentials:</p>
                  <ul className="text-xs text-text-muted space-y-1">
                    <li>Username: <span className="text-text-main dark:text-white font-mono">Netraa</span></li>
                    <li>Password: <span className="text-text-main dark:text-white font-mono">Apmosys@123</span></li>
                  </ul>
                </div>
              </div>
              <div className="flex gap-4">
                <span className="text-xs font-bold w-6 h-6 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center shrink-0 mt-0.5">3</span>
                <p className="text-sm"><span className="font-bold">Access UI:</span> Open your browser and navigate to <code className="bg-gray-100 dark:bg-white/10 px-1 py-0.5 rounded">http://&lt;server-ip&gt;</code>.</p>
              </div>
            </div>
            <div className="space-y-4">
              <div className="flex gap-4">
                <span className="text-xs font-bold w-6 h-6 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center shrink-0 mt-0.5">4</span>
                <p className="text-sm"><span className="font-bold">Apply License:</span> Go to Settings &gt; License and copy your unique System ID then Upload the received <code className="font-mono">license.key</code> file via the portal.</p>
              </div>
              <div className="flex gap-4">
                <span className="text-xs font-bold w-6 h-6 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center shrink-0 mt-0.5">5</span>
                <p className="text-sm"><span className="font-bold">Start:</span> Perform a soft-restart of the UI service to apply limits.</p>
              </div>
            </div>
          </div>

          <div className="bg-green-50 dark:bg-green-900/10 border border-green-200 dark:border-green-900/30 p-6 rounded-xl flex items-center gap-6">
            <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center text-white shrink-0">
              <span className="material-symbols-outlined text-[28px]">check_circle</span>
            </div>
            <div>
              <h4 className="text-lg font-bold text-green-800 dark:text-green-300">Deployment Successful!</h4>
              <p className="text-sm text-green-700 dark:text-green-400">Your Netraa Platform is now ready. Visit the getting started guide to begin onboarding applications.</p>
            </div>
          </div>
        </div>
      </section>
      </div>
  </div>
);
//       return (
//   <div>
//     <main className="transition-opacity duration-300">
//   <div className="py-10">
//     {/* Breadcrumbs */}
//     <nav className="flex flex-wrap items-center gap-2 text-sm text-[#9a734c] mb-8">
//       <a className="hover:text-primary hover:underline" href="#">Netraa APM</a>
//       <FiChevronRight className="text-[14px]" />
//       <span>Deployment and Configuration</span>
//       <FiChevronRight className="text-[14px]" />
      
//       <span className="text-[#1b140d] dark:text-white font-medium">Offline Setup Guide</span>
//     </nav>
//       {/* Intro */}
//       <div className="mb-10">
//         <span className="inline-block px-3 py-1 mb-4 text-xs font-bold tracking-wider text-orange-600 uppercase bg-orange-100 rounded-full dark:bg-orange-900/30 dark:text-orange-400">
//           Documentation
//         </span>
//         <h1 className="text-3xl lg:text-4xl font-extrabold text-text-main dark:text-white tracking-tight mb-4">
//           <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-600">Netraa{""} </span>On-Prem Installation Guide
//         </h1>
//         <p className="text-lg text-text-muted dark:text-gray-400 max-w-3xl leading-relaxed"> 
//           A comprehensive guide for deploying the full Netraa observability platform in enterprise, air-gapped, or on-premises environments.
//         </p>
//       </div>

//       {/* Deployment Summary Cards */}
//       <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-8">
//         {[
//           { title: "Deployment Environment", value: "Offline / Air-Gapped" },
//           { title: "Operating System", value: "RHEL 9.x" },
//           { title: "Container Runtime", value: "Docker CE / Compose" },
//         ].map((item, idx) => (
//           <div key={idx} className="bg-surface-light dark:bg-surface-dark p-4 rounded-xl border border-border-color dark:border-border-dark shadow-sm">
//             <p className="text-[10px] uppercase font-bold text-text-muted mb-1">{item.title}</p>
//             <p className={`text-sm font-bold ${idx === 0 ? "text-primary" : "text-text-main dark:text-white"}`}>{item.value}</p>
//           </div>
//         ))}
//       </div>

//       {/* Important Note */}
//       <div className="bg-amber-50 dark:bg-amber-900/20 border-l-4 border-amber-500 p-4 mb-12 rounded-r-lg">
//         <div className="flex items-center gap-2 mb-1">
//           <span className="material-symbols-outlined text-amber-600 dark:text-amber-400 text-sm">warning</span>
//           <h4 className="text-sm font-bold text-amber-800 dark:text-amber-300">IMPORTANT NOTE</h4>
//         </div>
//         <p className="text-xs text-amber-700 dark:text-amber-400 leading-relaxed">
//           This guide is specifically verified for <strong>RHEL 9</strong>. Ensure your system has the base OS repositories or the provided Netraa RPM bundle if operating in a fully restricted network.
//         </p>
//       </div>

//       {/* Architecture Section */}
//       <section className="mb-16 scroll-mt-24" id="architecture">
//         <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
//           <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-orange-100 dark:bg-orange-900/30 text-primary border border-orange-200 dark:border-orange-900/50">
//             <span className="material-symbols-outlined text-[24px]">schema</span>
//           </span>
//           Netraa Platform Architecture
//         </h2>
//         <div className="w-full aspect-[14/9] bg-gray-100 dark:bg-white/5 border border-dashed border-gray-300 dark:border-gray-700 rounded-xl flex flex-col items-center justify-center gap-4">
//           <img 
//     src={diagramImg}
//     alt="High-Level Platform Diagram"
//     className="w-45 h-45 object-contain"
//   />       
//         </div>
//       </section>

//       {/* Prerequisites */}
// <section className="mb-10 scroll-mt-24" id="prerequisites">
//   <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
//     <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-blue-100 dark:bg-blue-900/30 text-blue-600 border border-blue-200 dark:border-blue-900/50">
//       <span className="material-symbols-outlined text-[24px]">fact_check</span>
//     </span>
//     1. Common Prerequisites
//   </h2>

//   <div className="prose dark:prose-invert max-w-none text-sm space-y-2 mb-8">
//     <ul className="list-disc pl-5 space-y-1 text-text-muted dark:text-gray-400">
//       <li>Sudo or Root access to the host machine.</li>
//       <li>Firewalld/IPtables configured to allow internal container traffic.</li>
//       <li>A dedicated partition (for example, /data) is required on the VM to run our setup.</li>
//       <li>The Netraa Installation Bundle (<code className="font-mono">netraa-bundle.tar.gz</code>) downloaded and verified.</li>
//     </ul>
//   </div>
// </section>
// <section className="mb-16 scroll-mt-24" id="master-sizing">
//   <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
//     <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-green-100 dark:bg-green-900/30 text-green-600 border border-green-200 dark:border-green-900/50">
//       <span className="material-symbols-outlined text-[24px]">dvr</span>
//     </span>
//     Environment Specifications Matrix
//   </h2>

//   {/* <h3 className="text-center text-lg font-bold text-text-main dark:text-gray-200 mb-6">
//     Environment Specifications Matrix
//   </h3> */}

//   {/* Narrow container with horizontal scroll */}
//   <div className="overflow-x-auto border border-border-color dark:border-border-dark rounded-xl">
//   <table className="w-full text-left border-collapse">

//     {/* HEADER */}
//     <thead className="text-[11px]">
//       <tr>
//         <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
//           Deployment Scale
//         </th>
//         <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
//           Component
//         </th>
//         <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted text-center border border-border-color dark:border-border-dark">
//           Qty
//         </th>
//         <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
//           OS
//         </th>
//         <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
//           CPU (Cores)
//         </th>
//         <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
//           Memory (GB)
//         </th>
//         <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
//           Storage
//         </th>
//         <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
//           Source
//         </th>
//         <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
//           Ports
//         </th>
//         <th className="px-3 py-4 text-[10px] font-bold uppercase text-text-muted border border-border-color dark:border-border-dark">
//           Software
//         </th>
//       </tr>
//     </thead>

//     {/* BODY */}
//     <tbody className="text-[11px]">

//       {/* Demo Env */}
//       <tr className="bg-white dark:bg-transparent">
//         <td className="px-3 py-4 font-bold text-primary border border-border-color dark:border-border-dark">
//           Demo Env
//         </td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">Single VM</td>
//         <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">1</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">Ubuntu 24.04+</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">6</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">16</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">250 GB</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">Internal/Monitoring</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">12001, 11800</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">Docker/Compose</td>
//       </tr>

//       {/* 10 Entities */}
//       <tr className="bg-gray-50/50 dark:bg-white/[0.02]">
//         <td className="px-3 py-4 font-bold align-top border border-border-color dark:border-border-dark" rowSpan={3}>
//           10 Entities (250 TPS)
//         </td>

//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">App Server</td>
//         <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">1</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark" rowSpan={3}>
//           Ubuntu 24.04 Minimal / RedHat 9 / CentOS 9 / Oracle Linux 9
//         </td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">8</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">16</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">100 GB SSD</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">Application Services</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">80, 443</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark" rowSpan={3}>
//           Docker v26.1.4, Docker Compose v2.28.1
//         </td>
//       </tr>

//       <tr className="bg-gray-50/50 dark:bg-white/[0.02]">
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">Netraa Cluster</td>
//         <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">1</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">8</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">32</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">200 GB SSD</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">Platform Engine</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">11800</td>
//       </tr>

//       <tr className="bg-gray-50/50 dark:bg-white/[0.02]">
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">DB Cluster</td>
//         <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">1</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">16</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">64</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">500 GB NVMe</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">ES + MySQL</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">9200, 3306</td>
//       </tr>

//       {/* 50 Entities */}
//       <tr>
//         <td className="px-3 py-4 font-bold align-top border border-border-color dark:border-border-dark" rowSpan={3}>
//           50 Entities (250 TPS)
//         </td>

//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">App Server</td>
//         <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">2</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark" rowSpan={3}>
//           Ubuntu 24.04 Minimal / RedHat 9 / CentOS 9 / Oracle Linux 9
//         </td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">16</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">32</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">250 GB SSD</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">UI + Microservices</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">80, 443, 8080</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark" rowSpan={3}>
//           Docker v26.1.4, Docker Compose v2.28.1
//         </td>
//       </tr>

//       <tr>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">Netraa Cluster</td>
//         <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">2</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">16</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">64</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">500 GB SSD</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">Distributed Platform</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">11800</td>
//       </tr>

//       <tr>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">DB Cluster</td>
//         <td className="px-3 py-4 text-center border border-border-color dark:border-border-dark">3</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">32</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">128</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">1 TB NVMe</td>
//         <td className="px-3 py-4 border border-border-color dark:border-border-dark">HA Storage Layer</td>
//         <td className="px-3 py-4 font-mono border border-border-color dark:border-border-dark">9200, 9300, 3306</td>
//       </tr>

//     </tbody>
//   </table>
// </div>
// </section>
 
//             {/* Docker Installation */}
//       <section className="mb-10 scroll-mt-24" id="docker-install">
//         <h2 className="text-2xl font-bold text-text-main dark:text-white mb-6 flex items-center gap-3">
//           <span className="flex items-center justify-center w-10 h-10 rounded-lg bg-cyan-100 dark:bg-cyan-900/30 text-cyan-600 border border-cyan-200 dark:border-cyan-900/50">
//             <span className="material-symbols-outlined text-[24px]">terminal</span>
//           </span>
//           1.2 Docker & Docker Compose
//         </h2>
//         <p className="text-sm text-text-muted mb-4">
//           Install the core runtime engine using the RHEL-specific RPM packages provided in the bundle.
//         </p>
//         <CodeBlock code={`# Extract the platform bundle
// tar -xvf netraa-installer-rhel9.tar.gz
// cd netraa-installer/runtime
// # Install Docker using the local RPMs (RHEL 9)
// sudo dnf localinstall -y *.rpm
// # Verify installation and start service
// sudo systemctl enable --now docker
// docker --version
// docker compose version`} />
//       </section>

//       {/* PART 1: Database Layer */}
//       <section className="scroll-mt-24" id="part-1">
//         <div className="flex items-center gap-4 mb-2">
//           <span className="text-sm font-black bg-primary text-white w-8 h-8 rounded flex items-center justify-center shrink-0">1</span>
//           <h2 className="text-2xl font-bold text-text-main dark:text-white">PART 1: Database Layer</h2>
//         </div>
//         <div className="rounded-xl p-6">
//           <div>
//             <h4 className="text-sm font-bold mb-2">Image Loading</h4>
//             <p className="text-xs text-text-muted mb-3">Initialize the local registry with MySQL and Elasticsearch images.</p>
//             <CodeBlock code={`gunzip -c netraa-db-images.tar.gz | docker load`} />
//           </div>
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//             <div className="p-4 bg-gray-100 dark:bg-white/5 rounded-lg ">
//               <h5 className="text-xs font-bold uppercase text-text-muted mb-3 flex items-center gap-2">
//                 <span className="material-symbols-outlined text-[14px]">storage</span> Elasticsearch
//               </h5>
//               <CodeBlock code={`unzip elasticsearch.zip
// cd elasticsearch
// docker compose up -d`} />
//             </div>
//             <div className="p-4 bg-gray-100 dark:bg-white/5 rounded-lg ">
//               <h5 className="text-xs font-bold uppercase text-text-muted mb-3 flex items-center gap-2">
//                 <span className="material-symbols-outlined text-[14px]">database</span> MySQL
//               </h5>
//               <CodeBlock code={`unzip mysql-setup.zip
// cd mysql-setup
// docker compose up -d`} />
//             </div>
//           </div>
//         </div>
//       </section>

//       {/* PART 2: AOP Layer */}
//       <section className="scroll-mt-24" id="part-2">
//         <div className="flex items-center gap-4">
//           <span className="text-sm font-black bg-primary text-white w-8 h-8 rounded flex items-center justify-center shrink-0">2</span>
//           <h2 className="text-2xl font-bold text-text-main dark:text-white">PART 2: AOP Layer</h2>
//         </div>
//         <div className=" rounded-xl p-6">
//           <p className="text-sm text-text-muted mb-4">Deploy the Netraa AOP (Apmosys Observability Platform) core services.</p>
//           <CodeBlock code={`tar -xvf netraa-aop-v2.4.tar
// docker load -i netraa-aop-images.tar
// vi config/application.yml`} />
//           <p className="text-xs font-bold text-text-muted mb-2 uppercase">Configuration Snippet (application.yml)</p>
//           <CodeBlock code={`storage:
//   elasticsearch:
//     clusterNodes: "127.0.0.1:9200" # Update with your node IP
//     protocol: "http"`} />
//           <CodeBlock code={`docker compose up -d`} />

//           {/* <button className="mt-4 px-4 py-2 bg-text-main dark:bg-white text-white dark:text-text-main text-xs font-bold rounded">
//             docker compose up -d
//           </button> */}
//         </div>
//       </section>

//       {/* PART 3: Netraa APM Layer */}
//       <section className="scroll-mt-24" id="part-3">
//         <div className="flex items-center gap-4 mb-2">
//           <span className="text-sm font-black bg-primary text-white w-8 h-8 rounded flex items-center justify-center shrink-0">3</span>
//           <h2 className="text-2xl font-bold text-text-main dark:text-white">PART 3: Netraa APM Layer</h2>
//         </div>
//         <div className="bg-surface-light dark:bg-surface-dark rounded-xl p-6 shadow-subtle">
//           <p className="text-sm text-text-muted mb-4">Final stage: Deploying the UI and monitoring microservices cluster.</p>
//           <CodeBlock code={`tar -xvf netraa-apm-v2.4.tar
// docker load -i apm-services.tar
// vi .env`} />
//           <p className="text-xs font-bold text-text-muted mb-2 uppercase">Environment Parameters (.env)</p>
//           <CodeBlock code={`MYSQL_URL=jdbc:mysql://172.17.0.1:3306/netraa_db
// ELASTIC_HOST=172.17.0.1
// ELASTIC_PORT=9200
// AOP_ENDPOINT=http://aop-server:11800`} />
//           <div className="flex items-center gap-3">
//             <div className="flex-1 h-px"></div>
//             <span className="text-[10px] font-bold text-text-muted uppercase">Deployment Command</span>
//             <div className="flex-1 h-px"></div>
//           </div>
//           <CodeBlock code={`docker compose up -d`} />
//         </div>
//       </section>

//       {/* License Activation */}
//       <section className="scroll-mt-24" id="license-activation">
//         <div className="max-w-4xl">
//           <div className="text-center mb-10">
//             <h2 className="text-3xl font-extrabold text-text-main dark:text-white mb-4">License Activation & Finalization</h2>
//             <p className="text-text-muted text-gray-500">Follow these steps to authorize your on-prem installation.</p>
//           </div>

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
//             <div className="space-y-4">
//               <div className="flex gap-4">
//                 <span className="text-xs font-bold w-6 h-6 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center shrink-0 mt-0.5">1</span>
//                 <p className="text-sm"><span className="font-bold">Request Key:</span> Send the System ID to <code className="text-primary underline">support@netraa.io</code>.</p>
//               </div>
//               <div className="flex gap-4">
//                 <span className="text-xs font-bold w-6 h-6 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center shrink-0 mt-0.5">2</span>
//                 <div className="text-sm">
//                   <p className="font-bold mb-1">Default Credentials:</p>
//                   <ul className="text-xs text-text-muted space-y-1">
//                     <li>Username: <span className="text-text-main dark:text-white font-mono">Netraa</span></li>
//                     <li>Password: <span className="text-text-main dark:text-white font-mono">Apmosys@123</span></li>
//                   </ul>
//                 </div>
//               </div>
//               <div className="flex gap-4">
//                 <span className="text-xs font-bold w-6 h-6 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center shrink-0 mt-0.5">3</span>
//                 <p className="text-sm"><span className="font-bold">Access UI:</span> Open your browser and navigate to <code className="bg-gray-100 dark:bg-white/10 px-1 py-0.5 rounded">http://&lt;server-ip&gt;</code>.</p>
//               </div>
//             </div>
//             <div className="space-y-4">
//               <div className="flex gap-4">
//                 <span className="text-xs font-bold w-6 h-6 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center shrink-0 mt-0.5">4</span>
//                 <p className="text-sm"><span className="font-bold">Apply License:</span> Go to Settings &gt; License and copy your unique System ID then Upload the received <code className="font-mono">license.key</code> file via the portal.</p>
//               </div>
//               <div className="flex gap-4">
//                 <span className="text-xs font-bold w-6 h-6 rounded-full bg-gray-100 dark:bg-white/10 flex items-center justify-center shrink-0 mt-0.5">5</span>
//                 <p className="text-sm"><span className="font-bold">Start:</span> Perform a soft-restart of the UI service to apply limits.</p>
//               </div>
//             </div>
//           </div>

//           <div className="bg-green-50 dark:bg-green-900/10 border border-green-200 dark:border-green-900/30 p-6 rounded-xl flex items-center gap-6">
//             <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center text-white shrink-0">
//               <span className="material-symbols-outlined text-[28px]">check_circle</span>
//             </div>
//             <div>
//               <h4 className="text-lg font-bold text-green-800 dark:text-green-300">Deployment Successful!</h4>
//               <p className="text-sm text-green-700 dark:text-green-400">Your Netraa Platform is now ready. Visit the getting started guide to begin onboarding applications.</p>
//             </div>
//           </div>
//         </div>
//       </section>
//       </div>
//     </main>
//   </div>
// );
}